// Margin notes — move any .gg-post__note elements from inside
// .gg-prose (where Koenig places HTML cards) into the right-hand
// .gg-post__aside rail. Preserves the order they appear in the
// article. Below the 1000px grid breakpoint there is no rail, so
// notes stay inline next to the paragraph they annotate.
//
// Authoring pattern inside a Ghost post (via Koenig HTML card):
//
//   <div class="gg-post__note">
//     <span class="gg-post__note-key">Margin note</span>
//     The unit of training is the week, not the workout.
//   </div>

export default function marginNotes() {
    const aside = document.querySelector("[data-post-aside]");
    if (!aside) return;
    if (!window.matchMedia("(min-width: 1000px)").matches) return;

    const notes = document.querySelectorAll(".gg-prose .gg-post__note");
    if (!notes.length) return;

    notes.forEach((note) => aside.appendChild(note));
}
